import { Typography } from '@tempmee/react';
import { Colors } from '../../themes/colors';
import { useJobStatus } from './hooks/useJobStatus/useJobStatus';

export const JobStatusInfo = ({ job }) => {
  const { color, label } = useJobStatus(job);

  return (
    <div
      className="global_font"
      style={{
        margin: 0,
        fontSize: 18,
        fontWeight: 'bold',
        color: Colors.DarkGray,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        alignSelf: 'center',
        marginBottom: 16,
      }}
    >
      <Typography as="span" bold variant="body1">
        Status:
      </Typography>
      <Typography as="span" color={color} uppercase>
        {label || job?.status}
      </Typography>
    </div>
  );
};
